import React from "react";
import { ajaxGet } from "api/explus-api";
import Feeds from "../../Feeds/FeedsContainer";
//import HomeUpdates from "./HomeUpdates";
import HomeUpdatesV2 from "./HomeUpdatesV2";
import Events from "./Events";

const formatCurrency = value => {
    if (!value) {
        return;
    }

    return value.toLocaleString(navigator.language, {
        minimumFractionDigits: 0
    });
};

const HomeSidebarLeft = props => {
    let thepid = "";
    const onSubmit = () => {
        sessionStorage.clear();

        ajaxGet("web/changepid/" + thepid).then(data => {
            // ajaxGet('web/partners').then(dd => {
            // alert('New Data:' + dd);
            // })
            // console.log(data.pid);

            if (data.pid) {
                sessionStorage.setItem("pid", data.pid);
            }

            window.location.reload();
        });
    };

    const onChange = event => {
        thepid = event.target.value;
    };

    const admin = () => {
        if (
            localStorage.getItem("token") &&
            localStorage.getItem("permissions")
        ) {
            return (
                <div id="utility" className="">
                    {/* <h3>Login using PID</h3> */}
                    <div className="input-group">
                        <input
                            type="text"
                            name="pid"
                            onChange={onChange}
                            className="form-control"
                            placeholder="Login using PID"
                        />
                        <span className="input-group-btn">
                            <button
                                className="btn btn-default"
                                onClick={onSubmit}
                            >
                                Go
                            </button>
                        </span>
                    </div>

                    <hr />
                </div>
            );
        }
    };

    return (
        <div>
            <div className="island">
                <h2>Our Partnership</h2>
                {admin()}
                <ul className="partnership_details">
                    <li>
                        <span className="logo icon_partner_id">&nbsp;</span>
                        <span className="strong">Partner ID:</span>
                        <div className="details">
                            {props.partner.partner_id}
                        </div>
                    </li>

                    <li>
                        <span className="logo icon_name">&nbsp;</span>
                        <span className="strong">Name:</span>
                        <div className="details">
                            {props.partner.salutation}
                        </div>
                    </li>

                    <li>
                        <span className="logo icon_don">&nbsp;</span>
                        <span className="strong">Recent Donation:</span>
                        <div className="details">
                            {props.partner.receipt_date} Php{" "}
                            {formatCurrency(props.partner.amount)}
                        </div>
                    </li>

                    <li>
                        <span className="logo icon_don">&nbsp;</span>
                        <span className="strong">
                            Total Donation for the Year:
                        </span>
                        <div className="details">
                            Php{" "}
                            {formatCurrency(
                                props.partner.TotalPaymentForTheYear
                            )}
                        </div>
                    </li>
                </ul>
            </div>

            <div className="island">
                {/* <HomeUpdates partner={props.partner} /> */}
                <HomeUpdatesV2 partner={props.partner} />
            </div>

            <div className="island">
                <Events />
            </div>

            <div className="island">
                <Feeds childId={props.childId} />
            </div>
        </div>
    );
};

HomeSidebarLeft.defaultProps = {
    partner: {
        partner_id: "loading",
        salutation: "Title Sponsor",
        receipt_date: "date",
        amount: " amount",
        TotalPaymentForTheYear: " amount"
    }
};

export default HomeSidebarLeft;
